export enum UserRoles {
  USER = "USER",
  LAWYER = "LAWYER",
  PREMIUM = "PREMIUM",
  ADMIN = "ADMIN",
  AGENT = "AGENT",
}

export enum UserStatus {
  ACTIVE = "ACTIVE",
  DEACTIVE = "DEACTIVE",
  BLOCKED = "BLOCKED",
}

export enum BarStatus {
  ACTIVE = "ACTIVE",
  DEACTIVE = "DEACTIVE",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  emailValid: boolean;
  phone: string;
  phoneValid: boolean;
  roles?: UserRoles[];
  status: UserStatus;
  reason?: string;
  barStatus?: BarStatus;
  barNo?: number;
  barName?: string;
}

export interface GoogleUser {
  id: string;
  accessToken: string;
  idToken: string;
  email: string;
  verified_email: boolean;
  name: string;
  given_name: string;
  family_name: string;
  picture: string;
  locale: string;
}

export enum UserOrderBy {
  ID_ASC = "idAsc",
  ID_DESC = "idDesc",
  FIRST_NAME_ASC = "firstNameAsc",
  FIRST_NAME_DESC = "firstNameDesc",
  LAST_NAME_ASC = "lastNameAsc",
  LAST_NAME_DESC = "lastNameDesc",
  EMAIL_ASC = "emailAsc",
  EMAIL_DESC = "emailDesc",
  PHONE_ASC = "phoneAsc",
  PHONE_DESC = "phoneDesc",
  CREATE_DATE_ASC = "createDateAsc",
  CREATE_DATE_DESC = "createDateDesc",
}
